import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type ConnectionStatusSubscriptionVariables = Types.Exact<{ [key: string]: never; }>;


export type ConnectionStatusSubscription = { __typename?: 'Subscription', connectionStatusChanged: boolean };


export const ConnectionStatus = /*#__PURE__*/ gql`
    subscription ConnectionStatus {
  connectionStatusChanged
}
    ` as unknown as DocumentNode<ConnectionStatusSubscription, ConnectionStatusSubscriptionVariables>;

          

          export const useConnectionStatusSubscription = (options?:SubscriptionHookOptions<ConnectionStatusSubscription, ConnectionStatusSubscriptionVariables>) => useSubscription(ConnectionStatus, options);

          

          export type ConnectionStatusSubscriptionOptions = SubscriptionHookOptions<ConnectionStatusSubscription, ConnectionStatusSubscriptionVariables>;

          

          export type ConnectionStatusSubscriptionResult = ReturnType<typeof useConnectionStatusSubscription>;

          
